import type * as React from 'react';

export const SUGAR_HIGH_STYLE = {
  '--sh-class': 'var(--blue-700)',
  '--sh-identifier': 'var(--foreground)',
  '--sh-sign': 'var(--secondary-foreground)',
  '--sh-property': 'var(--pink-600)',
  '--sh-entity': 'var(--purple-700)',
  '--sh-jsxliterals': 'var(--cyan-700)',
  '--sh-string': 'var(--green-700)',
  '--sh-keyword': 'var(--indigo-700)',
  '--sh-comment': 'var(--secondary-foreground)',
} as React.CSSProperties;

export const INVERTED_SUGAR_HIGH_STYLE = {
  '--sh-class': 'var(--blue-200)',
  '--sh-identifier': 'var(--primary-foreground)',
  '--sh-sign': 'var(--primary-foreground)',
  '--sh-property': 'var(--pink-300)',
  '--sh-entity': 'var(--purple-300)',
  '--sh-jsxliterals': 'var(--cyan-300)',
  '--sh-string': 'var(--green-300)',
  '--sh-keyword': 'var(--indigo-300)',
  '--sh-comment': 'var(--primary-foreground)',
} as React.CSSProperties;
